 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"dde0be11da296399661d","1":"7e0781ca8740210f721e","2":"0662cdd1c6b54b4b0ea2","3":"03635851a1deda127b2c","4":"6b3ded0444117d932f39","5":"96aec9660d334d342e1a","6":"1aa9add4a7e0eccec7ec","7":"e4921a4daf76fc3d8869","vendors~Comment~ShareComment":"fe234cfb3c71cfe938fe","vendors~Comment~LoginDialog":"7c5020dc72754166c204","vendors~Comment~Survey":"ae5ee700530d76d6b13d","Comment":"23a782b5b352d43f281e","vendors~Player":"bc0ad2053746705be5bd","Player":"323b39ceee49658cb7a4","AccountOpening":"2effab80d8b75c77ab0c","BackTopBottom":"36423da13f2192e6d3c0","Caption":"6c50a7974ff8402762e2","Copyright":"a2846939a8c34a80660c","DataBox":"9413bd2e92b590055ac8","Img":"ceb3ef7599d71828a7db","LivePlayer":"7de1b0f87bc0d9d01d69","MoreTabs":"29139afe48b1448e4613","Nav":"dfc37be24a36e9008c82","NormalCaption":"eea2ec761dbd66511002","Offline":"fb0da445e487c992cbda","QQShare":"824accbedc2f9f14694b","Stick":"3ed6b56cf18cf24c9a7c","Tip":"8494f70a4f7e40fca141","ViewMoreLink":"e3c461785ce4c41b5bfc","WxLaunchApp":"6886caa3c765f48a4173","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"dd1c0a444d7f60f7c4d3","Atlas":"495e1828f8620022c620","FiveNavPic":"96a24035aa44edb5e159","FourNavPic":"0df59b6d9799e806dc7b","vendors~MdBanner":"b5548674689eaa195595","vendors~BigImage~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~CallupVideoAppHead~HomeFo~464104dc":"b294639cba7e4007169c","CallupVideoAppHead":"420987ccaa88d17bda56","HomeFooter":"ed6f8fc60b12f7d0ad0a","Hongbao":"5cfa5db8d3d4a1a3bd43","TwoImage":"1c0ad626df6a99c31398","ThreeNavPic":"7ba471c69f2ee1dc603a","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"c5c5260d6d2b80c7415e","BigImage":"db6ee6c256f632a0d29b","NoImage":"c2a6a54d616386c8cc8c","OneImage":"9c5552d16df7d8d9b064","ThreeImage":"daccd2e52ee4e767a061","vendors~NewsStream":"1621874c5a261908f84e","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"74443ebd5bec407518e6","SingleTitle":"f4dc401f15782320cce1","TwoImg":"5ae558c0c287f844596e","InformationFlow":"72f21ffbae1eec34c722","vendors~BigImg":"ff6bf5de4e8cb80e71ab","BigImg":"1561dedff4fd4df21791","vendors~BigTopic~TitleImg":"b97fe38507e7cb9b2155","BigTopic":"eac346439d538600e3c5","TitleImg":"ff240a57b266b20cb25c","vendors~SlideImg":"b0fb2564f4fb646690a5","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"5b49f38e5e8d94f1e78f","NormalSlides":"ac525cf20f89932e46a8","ShareSlides":"d2338d866022c7cef684","vendors~BottomSlides~UpgradeBottomSlides":"b64ae1a90098349f3b60","UpgradeBottomSlides":"0fed0eb086789266b8a9","vendors~IndexSlides":"7b61ffa208abd444d47b","vendors~BrowserGuideLayer":"93ca6884789d68c6ac4d","vendors~CallupHead":"9fcbe54fec52efd8ea09","vendors~ShareComment":"fdd70c8fa812563b7272","vendors~Survey":"3242acd3d2454da10116","vendors~NormalTabs":"db64c3b1218b518ff3bd","vendors~WXGuideLayer":"6f1438d77a3884e0466d","LoginDialog":"5653fa7fabe1ce277e01","vendors~MarkTabs":"7602f9c0891033f89c6d","vendors~PageBottomBrand":"2d02c31ab32953c16d9d","vendors~SimpleGuideLayer":"5b59337c139d8c61b0ee","vendors~SlidesTabs":"54ecb81a4f603e8e184a","vendors~pics":"f07f239aaab677f0f3a6","pics":"a16a6b2516cefa72fb1b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
